import { fromZonedTime, toZonedTime } from 'date-fns-tz';

import type { DateRepresentation } from './DateRepresentation';
import { defaultTimeZone } from './defaultTimeZone';
import { safeParseDate } from './parse/date';

export function getLocalTimezone(): string {
	return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function localTime(date: DateRepresentation, timeZone: string = defaultTimeZone): Date | undefined {
	// Parse the date to get the time in UTC
	const utcDate = safeParseDate(date);
	if (!utcDate) {
		return undefined;
	}

	// Convert to a local time
	const localTimeZone = timeZone ?? getLocalTimezone();
	return toZonedTime(utcDate, localTimeZone);
}

export function localTimeOperation(
	date: DateRepresentation,
	operation: (date: Date) => Date | undefined,
	timeZone: string = defaultTimeZone,
): Date | undefined {
	// Convert to a local time
	const localDate = localTime(date, timeZone);
	if (!localDate) {
		return undefined;
	}

	// Perform the operation on the local date
	const result = operation(localDate);
	if (!result) {
		return undefined;
	}

	// Convert back to UTC
	const localTimeZone = timeZone ?? getLocalTimezone();
	return fromZonedTime(result, localTimeZone);
}
